export default "__VITE_ASSET__DSLiKcWL__"